import { IApplicationState, TCardId } from '../../../../types/types';
import { getCardActiveRequests } from '../../../requestsState/selectors/getCardActiveRequests';

export const isCardHasActiveRequests = (
    state: IApplicationState,
    cardId: TCardId
) => {
    return getCardActiveRequests(state, cardId) > 0;
}
